import { createSelector } from "reselect";
import { populationIncidencePrevalenceChartDataSelector } from "../population_incidence_prevalence_chart_data_selector";

export const populationIncidencePrevalenceChartDataLoadStateSelector = createSelector(
  populationIncidencePrevalenceChartDataSelector,
  chartData => chartData.loadState
);
